import React from 'react';
import { buildingNext } from '../data/mock';
import { Card, Label, Marked } from './primitives';

const WhatsNext = () => {
  const goTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="next"
      className="bg-paper border-y-[1.5px] border-ink py-16 sm:py-24 scroll-mt-20"
    >
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <Label className="mb-3">What I'm building next</Label>
        <h2 className="text-2xl sm:text-4xl font-bold text-ink tracking-[-0.02em] max-w-4xl leading-tight">
          {buildingNext.question}
        </h2>
        <p className="mt-4 text-base sm:text-lg text-ink-soft leading-relaxed max-w-2xl">
          <Marked text={buildingNext.answer} />
        </p>

        <Card tint="blue" className="mt-9 sm:mt-10 p-5 sm:p-8">
          <Label className="mb-3 text-ink/60">Right now</Label>
          <ul className="space-y-2.5">
            {buildingNext.now.map((line) => (
              <li key={line} className="flex gap-2.5 text-sm sm:text-[15px] text-ink-soft leading-relaxed">
                <span className="text-flag select-none mt-[1px]">✦</span>
                <span>
                  <Marked text={line} />
                </span>
              </li>
            ))}
          </ul>
          <div className="mt-6 flex flex-wrap gap-3">
            <button
              onClick={() => goTo('#contact')}
              className="px-5 py-2.5 bg-ink text-cream text-sm font-semibold rounded-lg border-[1.5px] border-ink shadow-hard-sm hover:shadow-none hover:translate-x-[3px] hover:translate-y-[3px] transition-all"
            >
              Talk to me about it
            </button>
          </div>
        </Card>
      </div>
    </section>
  );
};

export default WhatsNext;
